/**
 * useSizeClass — the Size class and the Short height condition for the current screen.
 *
 * Width alone picks the size class: Split at 768px and wider, Single-pane under it.
 * Short height (under 700px) is separate, so a phone in landscape is Split and Short
 * height together. `CONTEXT.md` defines the terms.
 */

import { useMediaQuery } from '@mantine/hooks';

const SPLIT_QUERY = '(min-width: 48em)';
const FULL_HEIGHT_QUERY = '(min-height: 43.75em)';

// The app has no server render, so read the query during the first render. A wrong
// first value would mount the other arrangement for one frame.
const READ_ON_FIRST_RENDER = { getInitialValueInEffect: false };

interface UseSizeClassReturn {
  sizeClass: 'split' | 'single';
  /** Tightens chrome spacing only. It never hides a label or moves an action. */
  shortHeight: boolean;
}

export function useSizeClass(): UseSizeClassReturn {
  const split = useMediaQuery(SPLIT_QUERY, undefined, READ_ON_FIRST_RENDER);
  const fullHeight = useMediaQuery(FULL_HEIGHT_QUERY, undefined, READ_ON_FIRST_RENDER);
  return { sizeClass: split ? 'split' : 'single', shortHeight: !fullHeight };
}
